import { useContext } from 'react'
import { UgeEditorContext } from '../../contexts/editor'
import { Alert, Button } from './style'

type Props = {
    className?: string
}

const UgeNoLayersAlert = ({ className }: Props) => {
    const { openEditor } = useContext(UgeEditorContext)

    const onCaptionClick = () => {
        openEditor('captions')
    }

    const onStickersClick = () => {
        openEditor('stickers')
    }

    return (
        <Alert
            className={className}
            description="First add captions or stickers to your creation, then return here for layer tooling."
            stickerUrl="https://media.giphy.com/media/ViHbdDMcIOeLeblrbq/200w.gif"
            title="You don't have any layers, yet!"
        >
            <Button color="#000" size="medium" onClick={onCaptionClick}>
                Add Captions
            </Button>
            <Button color="#000" size="medium" onClick={onStickersClick}>
                Add Stickers
            </Button>
        </Alert>
    )
}

export default UgeNoLayersAlert
